import { Box, Typography } from '@mui/material'
import {
    CreateCompanyStep,
    useCreateCompanyContext,
} from '../CreateCompanyContext'

function StepLabels() {
    const { step } = useCreateCompanyContext()

    const label =
        step !== undefined
            ? (CreateCompanyStep[step].replace(/\B([A-Z])\B/g, ' $1') as any)
            : ''

    const isCreateAdminAccount = step === CreateCompanyStep.AdminAccount

    const isCompleted = step === CreateCompanyStep.Completed
    return isCompleted ? (
        <Box
            width={'100%'}
            mt={{
                xs: 2,
                sm: 2,
                md: 4,
            }}
        ></Box>
    ) : (
        <Box>
            <Typography variant="h5" color={'#fff'}>
                <b>{`${isCreateAdminAccount ? 'Create ' : ''}` + label}</b>
            </Typography>
        </Box>
    )
}

export default StepLabels
